import React, { Component } from 'react';
import language from '../../../assets/languages/language';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
import QuestionModeSetting from '../../../Components-2025/QuestionModeSetting';
import { EXAM_NAMES } from '../../../common/constant';
/* eslint-disable*/

class FrmQueBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      chapters: [],
      freeChapterCount: [],
      chapters_1: [],
      chapters_2: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
      selectedmenufrm: 'frm',
      lastRecordLevel1: '',
      lastAttemptLevel1: false,
      lastRecordLevel2: '',
      lastAttemptLevel2: false,
    };
    this.toggleAlert = this.toggleAlert.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  _getReadings = (chapter, e) => {
    this.context.router.push({
      pathname: `/frm/readings/${chapter.chapter_no}/${this.state.selectedmenufrm}/${
        chapter.level
      }/${chapter.chapter_name}`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        chapter: chapter.chapter_no,
        selectedMenu: this.state.selectedmenufrm,
        level: chapter.level,
        chapterName: chapter.chapter_name,
      },
    });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });
    if (localStorage.getItem('selectedmenu') == 'cfa') {
      this.context.router.push({
        pathname: '/dashboard/',
        state: {
          token: storage_session['token'],
          idname: storage_session['idname'],
        },
      });
    }

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    FD.callAPI(App_data.backend_api + '/frm_question_bank/getChapters', data).then(async (resp) => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          chapters: resp.chapters,
          freeChapterCount: resp.freeChapterCount,
        });
        //console.log(resp.chapters);
        var chapters_1_arr = [];
        var chapters_2_arr = [];
        var first_incr = 0;
        var second_incr = 0;
        for (var i = 0; i < resp.chapters.length; i++) {
          //console.log(resp.chapters[i]);
          if (resp.chapters[i].level == 1) {
            chapters_1_arr[first_incr] = resp.chapters[i];
            first_incr++;
          }
          if (resp.chapters[i].level == 2) {
            chapters_2_arr[second_incr] = resp.chapters[i];
            second_incr++;
          }
        }
        this.setState({
          chapters_1: chapters_1_arr,
          chapters_2: chapters_2_arr,
        });

        await FD.callAPI(
          App_data.backend_api + '/frm_question_bank/getlastAnsweredQuestionLevel1',
          data,
        ).then((response) => {
          if (response.success) {
            this.setState({
              lastRecordLevel1: response.dataLevel1,
              lastAttemptLevel1: true,
            });
          }
        });
        await FD.callAPI(
          App_data.backend_api + '/frm_question_bank/getlastAnsweredQuestionLevel2',
          data,
        ).then((response) => {
          if (response.success) {
            this.setState({
              lastRecordLevel2: response.dataLevel2,
              lastAttemptLevel2: true,
            });
          }
        });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  }

  goToQuestionLevel1 = async () => {
    const { lastRecordLevel1, lastAttemptLevel1 } = this.state;
    if (lastAttemptLevel1) {
      this.context.router.push({
        pathname:
          '/frm/chapter/' +
          lastRecordLevel1.questions_frm.chapter_id +
          '/' +
          lastRecordLevel1.questions_frm.reading_id +
          '/' +
          lastRecordLevel1.contentID +
          '/' +
          lastRecordLevel1.frmLevel +
          '/' +
          0,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapter: lastRecordLevel1.chapter_id,
          offset: 0,
          selectedMenu: 'frm',
        },
      });
    }
  };

  goToQuestionLevel2 = async () => {
    const { lastRecordLevel2, lastAttemptLevel2 } = this.state;
    if (lastAttemptLevel2) {
      this.context.router.push({
        pathname:
          '/frm/chapter/' +
          lastRecordLevel2.questions_frm.chapter_id +
          '/' +
          lastRecordLevel2.questions_frm.reading_id +
          '/' +
          lastRecordLevel2.contentID +
          '/' +
          lastRecordLevel2.frmLevel +
          '/' +
          0,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapter: lastRecordLevel2.chapter_id,
          offset: 0,
          selectedMenu: 'frm',
        },
      });
    }
  };
  render() {
    let chapters_1 = this.state.chapters_1;
    let countFree = this.state.freeChapterCount;
    const { lastAttemptLevel1, lastAttemptLevel2 } = this.state;
    let data = '';
    if (this.state.chapters_1.length && this.state.freeChapterCount.length) {
      data = chapters_1.map((item, index) =>
        countFree.map((itemFree, indexFree) =>
          item.chapter_no === itemFree.id && itemFree.level === 1 ? (
            <div
              className='col-md-6 col-lg-6 col-xl-4 free-premium-section question_box'
              key={item.id}
            >
              <div
                className='question_bank_wrap pointer_class'
                key={item.id}
                onClick={this._getReadings.bind(this, item)}
              >
                <div className='margin_bottom_30'>
                  <img
                    src={App_data.frontend_url + '/img/question_bank/icon2.svg'}
                    className=''
                    width='54'
                    alt=''
                  />
                </div>

                <div className='question_title' key={item.id} value={item.id}>
                  <a
                    className='pointer_class'
                    id={item.chapter_name}
                    value={item.id}
                    onClick={this._getReadings.bind(this, item)}
                  >
                    {item.chapter_no}. {item.chapter_name}
                  </a>
                </div>

                {/*<div className="card-block" key={item.chapter_name}>
                <p>Chapters: {item.Countreading}</p>
                <p>Free Questions: {item.free_questions}</p>
                <p>Premium Questions: {item.Countquestion}</p>
            </div>*/}

                <ul key={item.chapter_name}>
                  <li>
                    <span>
                      <img
                        src={App_data.frontend_url + '/img/question_bank/free_reading_icon.svg'}
                        className=''
                        width='25'
                        alt=''
                      />
                    </span>
                    <span>{item.Countreading}</span>
                    <div className='tootip_box'>{language.LC().TOTAL_READINGS}</div>
                  </li>
                  <li>
                    <span>
                      <img
                        src={App_data.frontend_url + '/img/question_bank/free_question_icon.svg'}
                        className=''
                        width='26'
                        alt=''
                      />
                    </span>
                    <span>{itemFree.count}</span>
                    <div className='tootip_box'>{language.LC().FREE_QUESTIONS}</div>
                  </li>
                  <li>
                    <span>
                      <img
                        src={App_data.frontend_url + '/img/question_bank/premium_question_icon.svg'}
                        className=''
                        width='23'
                        alt=''
                      />
                    </span>
                    <span>{item.Countquestion}</span>
                    <div className='tootip_box'>{language.LC().PREMIUM_QUESTIONS}</div>
                  </li>
                </ul>
              </div>
            </div>
          ) : null,
        ),
      );
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }

    let chapters_2 = this.state.chapters_2;
    let data_2 = '';
    if (this.state.chapters_2.length) {
      data_2 = chapters_2.map((item, index) =>
        countFree.map((itemFree, indexFree) =>
          item.chapter_no === itemFree.id && itemFree.level === 2 ? (
            <div
              className='col-md-6 col-lg-6 col-xl-4 free-premium-section question_box'
              key={item.id}
            >
              <div
                className='question_bank_wrap pointer_class'
                key={item.id}
                onClick={this._getReadings.bind(this, item)}
              >
                <div className='margin_bottom_30'>
                  <img
                    src={App_data.frontend_url + '/img/question_bank/icon2.svg'}
                    width='54'
                    className=''
                    alt=''
                  />
                </div>

                <div className='question_title' key={item.id} value={item.id}>
                  <a
                    className='pointer_class'
                    id={item.chapter_name}
                    value={item.id}
                    onClick={this._getReadings.bind(this, item)}
                  >
                    {item.id - 4}. {item.chapter_name}
                  </a>
                </div>

                <ul key={item.chapter_name}>
                  <li>
                    <span>
                      <img
                        src={App_data.frontend_url + '/img/question_bank/free_reading_icon.svg'}
                        className=''
                        width='25'
                        alt=''
                      />
                    </span>
                    <span>{item.Countreading}</span>
                    <div className='tootip_box'> {language.LC().TOTAL_READINGS} </div>
                  </li>
                  <li>
                    <span>
                      <img
                        src={App_data.frontend_url + '/img/question_bank/free_question_icon.svg'}
                        className=''
                        width='26'
                        alt=''
                      />
                    </span>
                    <span>{itemFree.count}</span>
                    <div className='tootip_box'>{language.LC().FREE_QUESTIONS}</div>
                  </li>
                  <li>
                    <span>
                      <img
                        src={App_data.frontend_url + '/img/question_bank/premium_question_icon.svg'}
                        className=''
                        width='23'
                        alt=''
                      />
                    </span>
                    <span>{item.Countquestion}</span>
                    <div className='tootip_box'>{language.LC().PREMIUM_QUESTIONS}</div>
                  </li>
                </ul>
              </div>
            </div>
          ) : null,
        ),
      );
    } else {
      data_2 = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }

    return (
      <div className='animated fadeIn'>
        <div className='row'>
          <div className='col-sm-12 col-md-12 margin_bottom_20 frm_title_logo_wrap'>
            <h1 className='section_head'> {language.LC().QUESTION_BANK} </h1>
            <img
              src={App_data.frontend_url + '/img/GARP_logo.png'}
              className='garpLogo'
              alt='full logo'
            />
            <div className='align-self-center'>
              <QuestionModeSetting examNameKey={EXAM_NAMES.FRM} />
            </div>
          </div>
        </div>
        <div className='margin_bottom_20 d-flex justify-content-between last_question_read_FRM'>
          <h1 className='section_head'> {language.LC().FRM_LEVEL_I_TOPICS} </h1>

          {lastAttemptLevel1 ? (
            <button
              className='btn btn-primary pointer_class'
              onClick={this.goToQuestionLevel1.bind(this)}
              disabled={!lastAttemptLevel1}
            >
              {' '}
              {language.LC().GO_TO_MY_LAST_QUESTION_ANSWERED}{' '}
            </button>
          ) : null}
        </div>
        <div className='row'>
          <div className='col-sm-12 col-md-12 seperator-block-wrap'>
            <div className='card'>
              <div className='card-block'>
                <div className='card-block'>
                  <div className='row'>{data}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div className='margin_bottom_20 d-flex justify-content-between last_question_read_FRM'>
          <h1 className='section_head'> {language.LC().FRM_LEVEL_II_TOPICS} </h1>
          {lastAttemptLevel2 ? (
            <button
              className='btn btn-primary pointer_class'
              onClick={this.goToQuestionLevel2.bind(this)}
              disabled={!lastAttemptLevel2}
            >
              {' '}
              {language.LC().GO_TO_MY_LAST_QUESTION_ANSWERED}{' '}
            </button>
          ) : null}
        </div>
        <div className='row'>
          <div className='col-sm-12 col-md-12 seperator-block-wrap'>
            <div className='card'>
              <div className='card-block'>
                <div className='card-block'>
                  <div className='row'>{data_2}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FrmQueBank;



// WEBPACK FOOTER //
// ./src/views/FRM/FrmQueBank/FrmQueBank.js